import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { ClientService } from '../../../core/services/client/client.service';

@Component({
    selector: 'app-select-school',
    templateUrl: './select-school.component.html',
    styleUrls: ['./select-school.component.scss'],
    standalone: false
})
export class SelectSchoolComponent implements OnInit, OnDestroy, OnChanges {

  @Input() clients: any;
  @Input() showCloseButton: boolean;
  @Output() selectClient = new EventEmitter<any>();
  @Output() closeClientSelect = new EventEmitter<any>();

  selectedClientSubscription: Subscription;

  constructor(private clientService: ClientService
  ) {
    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      if (client && client.checked) {
        this.onClose();
      }
    });
  }
  ngOnDestroy(): void {
    this.clientService.handleClientList(true);
    this.selectedClientSubscription.unsubscribe();
    this.clientService.moduleChangedevent(null);
    this.clientService.handleSchoolSelectPage(true);
  }

  // clients = [];
  filteredClients: Observable<any[]>;
  clientControl = new UntypedFormControl();

  ngOnInit() {
    this.filteredClients = this.clientControl.valueChanges
      .pipe(
        startWith<string | any>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => this._filter(name))
      );


  }

  ngOnChanges(changes: SimpleChanges): void {
    // When the bound client list is refreshed (e.g. switching modules), re-run the
    // autocomplete filter so the dropdown reflects the new list immediately instead
    // of only after the panel is closed and reopened.
    if (changes['clients'] && !changes['clients'].firstChange) {
      this.clientControl.setValue(this.clientControl.value ?? '');
    }
  }

  setDefaultClient() {
    if (this.clients.length === 1) {
      setTimeout(() => {
        this.clientControl.setValue(this.clients[0]);
      }, 200);
    } else {
      this.clientControl.setValue('');
    }
  }

  closed() {
    setTimeout(() => {
      if (
        this.clientControl.value === '' ||
        this.clientControl.value === null ||
        typeof this.clientControl.value === 'string' ||
        this.clientControl.value.Number == null
      ) {
        this.clientControl.setValue('');
      }
    }, 300);
  }

  private _filter(name: string) {
    let emptyClient = [{
      Name: 'No Client(s) Found',
      Id: 0,
      Number: 0,
      EnrollmentEnabled: true
    }];
    if(!name)
    {
      return this.clients.length > 0 ? this.clients : emptyClient;
    }
    const filterValue = name.toLowerCase();

    let filteredClients = this.clients.filter(option => {
      return option.Name.toLowerCase().replace(' - ', ' ').indexOf(filterValue) > -1
        || option.Name.toLowerCase().indexOf(filterValue) > -1
        || option.Number.toString().indexOf(filterValue) > -1
        || this.displayFn(option).toLowerCase().indexOf(filterValue) > -1;
    });

    filteredClients = filteredClients.length === 0 ? emptyClient : filteredClients;
    return filteredClients;
  }

  displayFn(client) {
    if (typeof client === 'string') {
      return undefined;
    }

    return (client && client.Number ? client.Name + ' (' + client.Number + ')' : undefined);
  }

  onClose() {
    this.closeClientSelect.emit(true);
  }

  selectSchool() {
    if (typeof this.clientControl.value !== 'object') {
      const selectedClient = this.clients.find((client: { Number: any; }) => {
        return client.Number.toString() === this.clientControl.value;
      });
      if (selectedClient) {
        this.clientControl.setValue(selectedClient);
      } else {
        return;
      }
    }

    if (this.clientControl.value) {
      this.selectClient.emit(this.clientControl.value);
    }
  }
}
